module.exports = __webpack_public_path__ + "img/10.8ed9a48b.webp";